import React from 'react';
import classes from './ExaminationFrames.module.css';
import leftArrow from '../../assets/icons/chevron-left.svg';
import rightArrow from '../../assets/icons/chevron-right.svg';
import playIcon from '../../assets/icons/play-video.svg';
import pauseIcon from '../../assets/icons/pause-video.svg';
import { FramesListItem } from './FramesListItem';
import { format } from 'date-fns';
import { useTranslation } from '../../hooks/useTranslations';

type Props = {
  frames: string[];
  date?: Date;
};

const ExaminationFrames: React.FC<Props> = ({ frames, date }) => {
  const { translations } = useTranslation();
  const [selectedFrame, setSelectedFrame] = React.useState<number>(0);
  const [autoplay, setAutoplay] = React.useState<boolean>(false);
  const [selectedFrameUrl, setSelectedFrameUrl] = React.useState<string>();
  const [paginationIndex, setPaginationIndex] = React.useState(10);

  React.useEffect(() => {
    if (autoplay) {
      const interval = setInterval(() => {
        setSelectedFrame((prevIndex) => (prevIndex + 1) % frames.length);
      }, 700);
      return () => clearInterval(interval);
    }
  }, [autoplay, frames]);

  React.useEffect(() => {
    if (paginationIndex < frames.length) {
      const interval = setInterval(() => {
        setPaginationIndex(paginationIndex + 5);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [paginationIndex]);

  return (
    <div className={classes.container}>
      <div className={classes.largeImageContainer}>
        <img className={classes.largeImage} src={selectedFrameUrl} alt={selectedFrameUrl} />
        {selectedFrame < frames.length - 1 && (
          <img
            className={classes.rightArrow}
            onClick={() => {
              if (selectedFrame < frames.length - 1) {
                setAutoplay(false);
                setSelectedFrame(selectedFrame + 1);
              }
            }}
            src={rightArrow}
            alt={'left arrow'}
          />
        )}
        <img
          className={classes.leftArrow}
          onClick={() => {
            if (selectedFrame > 0) {
              setAutoplay(false);
              setSelectedFrame(selectedFrame - 1);
            }
          }}
          src={leftArrow}
          alt={'left arrow'}
        />
        <div className={classes.autoplayButton}>
          <img
            className={classes.autoplayButtonIcon}
            alt={'play/stop'}
            src={autoplay ? pauseIcon : playIcon}
            onClick={() => setAutoplay(!autoplay)}
          />
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div className={classes.smallFramesContainer}>
          {frames.slice(0, paginationIndex).map((frame, index) => (
            <FramesListItem
              key={index}
              index={index}
              attachmentUrl={frame}
              selectedFrame={selectedFrame}
              setSelectedFrame={() => {
                setSelectedFrame(index);
              }}
              setSelectedUrl={(srcUrl) => setSelectedFrameUrl(srcUrl)}
            />
          ))}
        </div>
      </div>
      {date && (
        <div style={{ color: 'rgba(128, 148, 174, 1)' }}>
          <span style={{ marginRight: 4 }}>
            {translations('examinations.date')}/{translations('examinations.time')}
          </span>
          {format(date, 'dd.MM.yyyy')} • {format(date, 'HH:mm')}
        </div>
      )}
    </div>
  );
};

export { ExaminationFrames };
